module.exports = __webpack_public_path__ + "img/restaurant-demo.59214b18.jpg";